export default __webpack_public_path__ + "static/media/dialog-futuristic-secondary-fbg.71f1dfd5.svg";